// extracted by mini-css-extract-plugin
export default {"gallery":"Gallery_gallery__EQA0o","album":"Gallery_album__ihgSa"};